var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92 54.066V35c0-.545-.146-1.078-.428-1.544L75.321 6.365A9.058 9.058 0 0 0 67.602 2H26.398a9.055 9.055 0 0 0-7.72 4.368L2.428 33.456A2.977 2.977 0 0 0 2 35v48c0 4.963 4.037 9 9 9h43.066C58.702 95.745 64.59 98 71 98c14.889 0 27-12.111 27-27 0-6.41-2.255-12.298-6-16.934zM50 8h17.602c1.049 0 2.036.56 2.575 1.456L83.701 32H50zM23.823 9.459A3.02 3.02 0 0 1 26.398 8H44v24H10.299zM8 83V38h78v10.565A26.84 26.84 0 0 0 71 44c-14.889 0-27 12.111-27 27a26.84 26.84 0 0 0 4.565 15H11c-1.655 0-3-1.345-3-3zm63 9c-11.578 0-21-9.422-21-21s9.422-21 21-21 21 9.422 21 21-9.422 21-21 21zm-3-9a2.99 2.99 0 0 1-2.121-.879l-9-9c-1.172-1.172-1.172-3.07 0-4.242s3.07-1.172 4.242 0L68 75.758l12.879-12.879c1.172-1.172 3.07-1.172 4.242 0s1.172 3.07 0 4.242l-15 15A2.99 2.99 0 0 1 68 83zM32 53H20c-1.658 0-3-1.342-3-3s1.342-3 3-3h12c1.658 0 3 1.342 3 3s-1.342 3-3 3z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderProcessing);
export default __webpack_public_path__ + "static/media/order-processing.4ca99e544a048f7b031698bcb33e1f69.svg";
export { ForwardRef as ReactComponent };